/**
 * Sign out by clearing local OIDC tokens and redirecting to Cognito's
 * logout endpoint. Cognito invalidates its server-side session, then
 * redirects to the logout page.
 */
export function signOut(): void {
  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

  // Clear local OIDC tokens before navigating away
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith('oidc.')) {
      localStorage.removeItem(key);
    }
  }

  // Use the current origin so logout redirects back to whichever domain the user is on.
  const redirectUri = encodeURIComponent(`${globalThis.location.origin}/`);
  globalThis.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code`;
}
